import React from 'react'
import { Button } from '@mui/material'
import SubtitlesIcon from '@mui/icons-material/Subtitles'
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff'

type Props = {
  onClick: (visible: boolean) => void
  isVisible: boolean
}

export const LegendControlButton = ({ onClick, isVisible }: Props) => {
  return (
    <Button
      startIcon={ isVisible ? <SubtitlesIcon /> : <SubtitlesOffIcon /> }
      variant="contained" size='small'
      onClick={() => onClick(!isVisible)}
      sx={{ pointerEvents: 'painted', py: '3px' }}
    >
      凡例
    </Button>
  )
}
